import { Component } from '@angular/core';

@Component({
  selector: 'app-corporate-information',
  templateUrl: './corporate-information.component.html',
  styleUrls: ['./corporate-information.component.scss']
})
export class CorporateInformationComponent {

}
